// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Journey-Service (J-S::B2C) API
 * ## SBB Journey-Planner  (de:Fahrplanpublikation Personenverkehr SBB)  This is a stateless RESTful web-service for **timetable based public transportation routing** as provided by SBB Journey-Planner applications such as [sbb.ch](https://www.sbb.ch/) or [SBB Mobile App](https://apps.apple.com/ch/app/sbb-mobile/id294855237). The service-contract is restricted to **SBB internal consumers** or **accredited partners** and supports various and enhanced use cases.  ### Before \'Sign up\'  For new consumers: 1. This **service needs official approval** before granting any access, therefore send an e-mail (see \'Contact -> E-Mail\') first with the subject: **Request: Sign Up Journey-Service** 2. Wait for the appropriate response e-mail and fill-in the attached **Questionnaire** and follow further steps given in the response.    ### Approved and \'Signed up\' consumers See **Contact** box * **Homepage** for general infos about the service  * **Developer resources** for specific usage and concepts of Journey-Service  See **Blog** on PRODuction for Release-Notes.  Remark: * Please read the **Service-Contract** description in Swagger-Doc carefully. * For further questions, send an e-Mail.  
 *
 * The version of the OpenAPI document: 3.20.32.2
 * Contact: journey-service@sbb.ch
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * A characterisation of the public transport operation according to the means of transport (aka OJP PtMode; Siri::VehicleMode; v580 TransportMode or de:Verkehrsmittelkategorie). Whether only `id` is given or submode as well depends on available data.
 * @export
 * @interface VehicleMode
 */
export interface VehicleMode {
    /**
     * Mode of public transportation according to **v580 TransportMode** (see [de:Verkehrsmittelkategorie](https://www.allianceswisspass.ch/de/tarife-vorschriften/uebersicht/V580/Produkte-der-V580-FIScommun-1)) given  by [opentransportdata.swiss Transportmodes (de:Verkehrsmittel)](https://opentransportdata.swiss/de/dataset/vm-liste) column `EN` as uppercase.<br>x-extensible-enum: values see `VehicleModeEnum`.
     * @type {string}
     * @memberof VehicleMode
     */
    id: string;
    /**
     * Translation of related `id` (according to Accept-Language and [opentransportdata.swiss Transportmodes (de:Verkehrsmittel)](https://opentransportdata.swiss/de/dataset/vm-liste) language column).<br>(Translated according to Accept-Language.)
     * @type {string}
     * @memberof VehicleMode
     */
    name: string;
    /**
     * Icon-identifier to represent the related `id` (rough main mode like TRAIN, BUS, ..). See [SBB Corporate-Identity catalog (CDN, aka FIGMA Icons)](https://www.figma.com/file/UQBd7cHKav0hr9oXYp7opJ/SBB-Icons?node-id=395%3A2952&t=ad26LgREBbTANSK5-1)
     * @type {string}
     * @memberof VehicleMode
     */
    corporateIdentityIcon: string;
    /**
     * Long, displayable submode (aka de:Gattung) related to (main) mode `id`. See [v580 de:Verkehrsmittelkategorien (aka Transmodel or OJP/Siri `VehicleMode`)](https://github.com/SchweizerischeBundesbahnen/journey-service/blob/master/business/TransportMode.md)
     * @type {string}
     * @memberof VehicleMode
     */
    vehicleSubModeName?: string;
    /**
     * Short version of related `vehicleSubModeName`.
     * @type {string}
     * @memberof VehicleMode
     */
    vehicleSubModeShortName?: string;
}

/**
 * Check if a given object implements the VehicleMode interface.
 */
export function instanceOfVehicleMode(value: object): value is VehicleMode {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('corporateIdentityIcon' in value) || value['corporateIdentityIcon'] === undefined) return false;
    return true;
}

export function VehicleModeFromJSON(json: any): VehicleMode {
    return VehicleModeFromJSONTyped(json, false);
}

export function VehicleModeFromJSONTyped(json: any, ignoreDiscriminator: boolean): VehicleMode {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'corporateIdentityIcon': json['corporateIdentityIcon'],
        'vehicleSubModeName': json['vehicleSubModeName'] == null ? undefined : json['vehicleSubModeName'],
        'vehicleSubModeShortName': json['vehicleSubModeShortName'] == null ? undefined : json['vehicleSubModeShortName'],
    };
}

  export function VehicleModeToJSON(json: any): VehicleMode {
      return VehicleModeToJSONTyped(json, false);
  }

  export function VehicleModeToJSONTyped(value?: VehicleMode | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'corporateIdentityIcon': value['corporateIdentityIcon'],
        'vehicleSubModeName': value['vehicleSubModeName'],
        'vehicleSubModeShortName': value['vehicleSubModeShortName'],
    };
}

